// extracted by mini-css-extract-plugin
export default {"imageContainer":"Home_imageContainer__E8Sr6","imageForArtist":"Home_imageForArtist__WmaA2"};